import { HttpRequest, HttpMethod } from "./http";
import AppCatalogProductProvider from "./app_catalog_product";
import AppCatalogPromotionBundleProvider from "./app_catalog_promotion_bundle";

// Ad landing pages — BO CRUD on the App PG (Phase 1 ads spec 2026-10-13 §3.2).
// Envelope: {data: …} (+ total on the list). Errors carry a stable `code`:
// schema_missing (503), invalid_slug, slug_taken, stale_draft,
// publish_invalid (+ errors[{section_id, field, rule}]), is_published,
// invalid_link, invalid_content_type. Action routes are POST /:id/<verb>.
const BASE = "/api/v1/bo/landing-pages";

const products = new AppCatalogProductProvider();
const promotions = new AppCatalogPromotionBundleProvider();

class LandingPageProvider extends HttpRequest {
    // ?status=draft|published|archived|live|scheduled|ended&q=&page=1&limit=20
    list(params) {
        return this.request(HttpMethod.Get, BASE, params);
    }

    // {data:{available, reason: ""|"format"|"taken"|"reserved"|"old_slug"}}
    checkSlug(slug, id) {
        const params = { slug };
        if (id) params.id = id;
        return this.request(HttpMethod.Get, `${BASE}/check-slug`, params);
    }

    create(payload) {
        return this.request(HttpMethod.Post, BASE, payload);
    }

    get(id) {
        return this.request(HttpMethod.Get, `${BASE}/${id}`);
    }

    // {title, slug, starts_at, ends_at, fallback_url, seo, sections, expected_updated_at}
    update(id, payload) {
        return this.request(HttpMethod.Put, `${BASE}/${id}`, payload);
    }

    publish(id, expectedUpdatedAt) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/publish`, { expected_updated_at: expectedUpdatedAt });
    }

    unpublish(id) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/unpublish`, {});
    }

    archive(id) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/archive`, {});
    }

    duplicate(id, payload) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/duplicate`, payload);
    }

    remove(id) {
        return this.request(HttpMethod.Delete, `${BASE}/${id}`);
    }

    revisions(id) {
        return this.request(HttpMethod.Get, `${BASE}/${id}/revisions`);
    }

    restore(id, version) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/revisions/${version}/restore`, {});
    }

    rotatePreviewToken(id) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/preview-token`, {});
    }

    // {file_name, content_type} → {upload_url, cdn_url, object_key, expires_in}.
    // object_type is forced to "storefront" server-side; video/mp4 allowed here only.
    presign(payload) {
        return this.request(HttpMethod.Post, `${BASE}/uploads/presign`, {
            file_name: payload.file_name,
            content_type: payload.content_type
        });
    }

    // Pickers (same endpoints as the home editor) — routed through this
    // service so the mock provider can stand in for them too.
    searchProducts(params) {
        return products.list(params);
    }

    getProduct(id) {
        return products.get(id);
    }

    listPromotions(params) {
        return promotions.list(params);
    }
}

export default LandingPageProvider;
